import { useEffect, useState } from 'react'
import { Box, Typography, useTheme, Dialog, IconButton, Button } from '@mui/material'
import { Close } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { calendlyUrl } from 'config/config'
import { trackEvent } from 'services/amplitudeTracking'
import SharePublicRolePlayButton from './SharePublicRolePlayButton'

const PublicRolePlayBookDemo = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const [dialogOpen, setDialogOpen] = useState(false)
  const [bookDemo, setBookDemo] = useState(false)
  const [timeoutID, setTimeoutID] = useState(null)

  useEffect(() => {
    const timeoutID = setTimeout(() => {
      setDialogOpen(true)
    }, 60000)
    setTimeoutID(timeoutID)
  }, [])

  useEffect(() => {
    if (bookDemo) {
      clearTimeout(timeoutID)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bookDemo])

  const CloseButton = ({ onClick, sx = {} }) => (
    <IconButton
      onClick={onClick}
      sx={{ position: 'absolute', right: '2%', top: '2%' }}>
      <Close />
    </IconButton>
  )

  const btnSx = {
    padding: '12px 24px'
  }

  return (
    <>
      <Box sx={theme.publicRolePlay.result.bookDemoWrapper}>
        <Box sx={theme.publicRolePlay.result.bookDemoBox}>
          <Button
            onClick={() => {
              setBookDemo(true)
              trackEvent('Book A Demo', { location: 'floating' })
            }}
            sx={btnSx}>
            {t('publicRolePlay.bookDemo')}
          </Button>
          <SharePublicRolePlayButton
            label={t('publicRolePlay.shareAIRE')}
            trackLocation={'floating'}
            btnSx={btnSx}
          />
        </Box>
      </Box>

      {/* Book demo today */}
      <Dialog
        disableScrollLock
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        sx={{
          ...theme.publicRolePlay.result.getResultPopup,
          textAlign: 'center'
        }}>
        <CloseButton onClick={() => setDialogOpen(false)} />

        <Typography sx={theme.publicRolePlay.result.heading}>
          {t('publicRolePlay.unlockFullPotential')}
        </Typography>

        <Button
          onClick={() => {
            setDialogOpen(false)
            setBookDemo(true)
            trackEvent('Book A Demo', { location: 'popup' })
          }}>
          {t('publicRolePlay.bookDemoToday')}
        </Button>
      </Dialog>

      {/* Calendly Popup */}
      <Dialog
        open={bookDemo}
        onClose={() => setBookDemo(false)}
        sx={theme.publicRolePlay.result.calendlyDialog}>
        <CloseButton onClick={() => setBookDemo(false)} />
        <iframe
          src={calendlyUrl}
          width='100%'
          height='100%'
          frameBorder='0'
          title='Select a Date &amp; Time - Calendly'></iframe>
      </Dialog>
    </>
  )
}

export default PublicRolePlayBookDemo
